export default __webpack_public_path__ + "cc3496b575ccc640d1d70fd992216729.png";